import { doorFromJSON, DoorRecord } from "common/records/Door";
import { IDoorData } from "common/records/Door";
import { IWindowData, windowFromJSON } from "common/records/Window";
import { WindowRecord } from "common/records/Window";
import { defaultMeasurementProps, IMeasurementData, IMeasurementRecord } from "common/records/Measurement";
import { IRoofFaceData, roofFaceFromJSON, RoofFaceRecord } from "common/records/RoofFace";
import { List, Record } from "immutable";
import { IRoomData, roomFromJSON, RoomRecord } from "common/records/Room";

export const hydratedMeasurementFromJSON = (json: Partial<IHydratedMeasurementData>) => {
  const recordData: IHydratedMeasurementRecord = { ...(json as any) };

  recordData.roof_faces = List(json.roof_faces?.map((rf) => roofFaceFromJSON(rf)));
  recordData.rooms = List(json.rooms?.map((rf) => roomFromJSON(rf)));
  recordData.windows = List(json.windows?.map((w) => windowFromJSON(w)));
  recordData.doors = List(json.doors?.map((d) => doorFromJSON(d)));

  return new HydratedMeasurementRecord(recordData);
};

export interface IHydratedMeasurementData extends IMeasurementData {
  roof_faces: IRoofFaceData[];
  rooms: IRoomData[];
  windows: IWindowData[];
  doors: IDoorData[];
}

export interface IHydratedMeasurementRecord extends IMeasurementRecord {
  roof_faces: List<RoofFaceRecord>;
  rooms: List<RoomRecord>;
  windows: List<WindowRecord>;
  doors: List<DoorRecord>;
}

const defaultMeasurementHydrateProps = {
  ...defaultMeasurementProps,
  roof_faces: List<RoofFaceRecord>(),
  rooms: List<RoomRecord>(),
  windows: List<WindowRecord>(),
  doors: List<DoorRecord>(),
};

export class HydratedMeasurementRecord
  extends Record(defaultMeasurementHydrateProps)
  implements IHydratedMeasurementRecord {}
